<template>
  <div style="width: 98%;position: relative;left: 16px;" v-if="visible">
    <b-tab title="Bitácora de Seguimiento" ref="bitacoraTab" lazy>
      <RequestDetail :request-number="item.requestNumberService" :status-color="hexaColor" :status-name="item.status" />
      <AddBlogItem :comment-types="commentTypes" :request-id="item.requestServiceId" @cancel="$emit('cancel')"
        @save="(data) => $emit('save', data)" />
    </b-tab>
    <b-tab title="Historial de Bitácora" lazy>
      <BitacoraHistoryTab :request-id="item.requestServiceId" :request-number="item.requestNumberService"
        :status-color="hexaColor" :status-name="item.status" />
    </b-tab>
  </div>
</template>

<script>
import AddBlogItem from "@/components/pei/ref/components/AddBlogItem";
import RequestDetail from "@/components/pei/ref/components/RequestDetail";
import BitacoraHistoryTab from "@/components/pei/ref/components/BitacoraHistoryTab";
import ThrpiesAdmissionStatuses from "@/utils/constants/thrpiesAdmissionStatuses";

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
    },
    commentTypes: {
      type: Array,
      default: () => []
    },
  },
  components: {
    AddBlogItem,
    RequestDetail,
    BitacoraHistoryTab,
  },
  computed: {
    hexaColor() {
      let result = "";
      switch (this.item.statusId) {
        case ThrpiesAdmissionStatuses.ReferidoAlDirectorCSEE:
        case ThrpiesAdmissionStatuses.ReferidoRechazado:
          result = "#d5b89a";
        case ThrpiesAdmissionStatuses.ServicioRelacionadoActivo:
          result = "#A3E5B3";
        case ThrpiesAdmissionStatuses.Asignado:
        case ThrpiesAdmissionStatuses.Admitido:
        case ThrpiesAdmissionStatuses.Vinculado:
          result = "#f8ea8";
        case ThrpiesAdmissionStatuses.NoVinculado:
        case ThrpiesAdmissionStatuses.NoVinculadoDenegadoRemPro:
        case ThrpiesAdmissionStatuses.Alertas:
          result = "#fcc9c8";
        case ThrpiesAdmissionStatuses.AprobadoEnRemedioProvisional:
          result = "#ddb3d7";
        default:
          result = "#f8ca80";
      }

      return result;
    }
  },
};
</script>
